<template>
  <div class="stepper">
    <div
      :key="i"
      class="stepper__step"
      :class="{
        'stepper__step--done': step.done,
        'stepper__step--error': step.error,
        'stepper__step--selected': step.selected
      }"
      v-for="(step, i) in steps"
      @click="() => $emit('click', step.id)"
    >
      <div class="stepper__step__number">
        <strong>{{ i + 1 }}</strong>
      </div>
      {{ step.title }}
    </div>
    <div class="stepper__line"></div>
  </div>
</template>

<script>
export default {
  name: 'stepper',
  props: {
    currentStep: Number,
    steps: Array
  }
}
</script>

<style lang="scss" scoped>
.stepper {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  padding: 2rem 1rem 0 1rem;
  overflow-x: auto;

  &__step {
    display: flex;
    align-items: center;
    min-width: 180px;
    height: 40px;
    padding-left: 6px;
    margin-right: 3rem;
    margin-bottom: 1.5rem;
    background-color: #FFFFFF;
    border: 2px solid #A217AB;
    box-sizing: border-box;
    border-radius: 20px;
    color: #A217AB;
    z-index: 2;

    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;

    &__number {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: .5rem;
      background-color: #A217AB;
      color: #FFFFFF;
    }

    &--done {
      background-color: #4C91FF;
      border: none;
      color: #FFFFFF;

      .stepper__step__number {
        color: #4C91FF;
        background-color: #FFFFFF;
      }
    }
    &--error {
      background-color: #F67D88;
      border: none;
      color: #FFFFFF;

      .stepper__step__number {
        color: #F67D88;
        background-color: #FFFFFF;
      }
    }
    &--selected {
      background-color: #6253BC;
      border: none;
      color: #FFFFFF;

      .stepper__step__number {
        color: #6253BC;
        background-color: #FFFFFF;
      }
    }
  }

  &__line {
    position: absolute;
    top: calc(3rem + 8px);
    left: 2rem;
    right: 2rem;
    border: 1px dashed #7C8F99;
    z-index: 1;
  }
}
@media screen and (min-width: 641px) {
  .stepper{
    overflow-x: hidden;
    padding: 2rem 2rem 0 2rem;
    &__step {
      min-width: 200px;
      height: 48px;
      border-radius: 24px;
      margin-right: 0;
      &__number {
        width: 32px;
        height: 32px;
      }
    }
    &__line {
      left: 4rem;
      right: 4rem;
    }
  }
}
@media screen and (min-width: 769px) {
  .stepper{
    padding: 2rem 8rem 0 8rem;

    &__line {
      top: calc(2rem + 20px);
      left: 12rem;
      right: 10rem;
    }
  }
}
@media screen and (min-width: 1281px) {
  .stepper {
    flex-direction: column;
    padding: 2rem 0 0 24px;

    &__line {
      top: 2rem;
      left: 46px;
      height: calc(100% - 5rem);
      width: 0;
      border-right: none;
    }
  }
}
</style>
